import React, { useContext } from 'react';
import { noop } from '@linktivity/link-utils';

import { DateContextProps } from './DatePicker.types';

const defaultContext = {
  currentDate: new Date(),
  currentYear: 0,
  currentMonth: 0,
  setCurrentDate: noop,
  setView: noop,
  backToDateView: noop,
  disabledDate: () => false,
  dateOptions: undefined,
  preDateOptions: undefined
};

export const DateContext =
  React.createContext<DateContextProps>(defaultContext);

export const useDateContext = () => useContext(DateContext);
